import WindowResolver from './WindowResolver'


declare global {
  interface Window {
    ga(method: string, ...args: any[]): void
  }
}

/*

  From docs:

  window.ga('set', ...)
  window.ga('send', ...)

  Usage:

  ga.set(...)
  ga.send(...)

 */

const windowEntity = 'ga'

const methods = {
  set: true,
  send: true,
}

interface IGa {
  set(name: 'set', fieldName: string, fieldValue: string): void
  set(name: 'set', fieldObject: { [key: string]: any }): void
  send(type: 'pageview', page?: string): void
  send(type: 'event', eventCategory: string, eventAction: string, eventLabel?: string, eventValue?: string): void
  send(type: 'event', eventData: {
    eventCategory: string, eventAction: string, eventLabel?: string, eventValue?: string
  }): void,
  send(type: 'social', socialNetwork: string, socialAction: string, socialTarget: string): void
  send(type: 'social', socialData: { socialNetwork: string, socialAction: string, socialTarget: string }): void
  send(type: 'timing', timingCategory: string, timingVar: string, timingValue: number, timingLabel?: string): void
  send(type: 'timing', timingData: {
    timingCategory: string, timingVar: string, timingValue: number, timingLabel?: string
  }): void
}

const ga = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.ga),
  eventHandler: (methodName, ...args) => {
    window.ga(methodName, ...args)
  },
}) as unknown as IGa


export default ga

export {
  windowEntity,
  methods,
}
